import { REPUBS } from '@cx-modules/constants';

import { isValidRepub } from './getRepubFromHeader';

export function getPathAndRepubFromUrlPath(urlPath: string) {
	const firstSegment = urlPath.split('/')[1]?.toUpperCase();
	if (!isValidRepub(firstSegment) || !REPUBS[firstSegment]) {
		return { repub: REPUBS.OC.name, path: urlPath };
	}

	const repub = REPUBS[firstSegment] ? firstSegment : REPUBS.OC.name;

	const pathWithoutRepub = `/${urlPath.split('/').slice(2).join('/')}`;
	const path = repub === REPUBS.OC.name ? urlPath : pathWithoutRepub;

	return {
		repub,
		path,
	};
}
